import { ref, watchEffect } from "@nuxtjs/composition-api";
function generatePagination(options) {
  const { currentPage, pageRange, pagesCount, marginPages } = options;
  const items = [];
  const addItem = (index) => {
    items[index] = {
      index,
      content: index + 1,
      selected: index === currentPage - 1
    };
  };
  const setBreakView = (index) => {
    items[index] = { index, disabled: true, breakView: true };
  };
  if (pagesCount <= pageRange) {
    for (let i = 0; i < pagesCount; i += 1) {
      addItem(i);
    }
  } else {
    const halfPageRange = Math.floor(pageRange / 2);
    for (let i = 0; i < marginPages; i += 1) {
      addItem(i);
    }
    let selectedRangeLow = 0;
    if (currentPage - halfPageRange > 0) {
      selectedRangeLow = currentPage - 1 - halfPageRange;
    }
    let selectedRangeHigh = selectedRangeLow + pageRange - 1;
    if (selectedRangeHigh >= pagesCount) {
      selectedRangeHigh = pagesCount - 1;
      selectedRangeLow = selectedRangeHigh - pageRange + 1;
    }
    for (let i = selectedRangeLow; i <= selectedRangeHigh && i <= pagesCount - 1; i += 1) {
      addItem(i);
    }
    if (selectedRangeLow > marginPages) {
      setBreakView(selectedRangeLow - 1);
    }
    if (selectedRangeHigh + 1 < pagesCount - marginPages) {
      setBreakView(selectedRangeHigh + 1);
    }
    for (let i = pagesCount - 1; i >= pagesCount - marginPages; i -= 1) {
      addItem(i);
    }
  }
  return items;
}
function usePagination(options) {
  const pagination = ref(null);
  watchEffect(() => {
    pagination.value = generatePagination(options);
  });
  return { pagination };
}
var usePagination_default = usePagination;
export {
  usePagination_default as default
};
